import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useRollbackOperationModal } from '../context/RollbackOperationModalContext';

const RollbackOperationModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useRollbackOperationModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">
        {' '}
        <em className="icon icon-circle ni ni-alert-fill bg-danger text-white" />
        &nbsp;&nbsp;{t('RollbackOperation')}&nbsp;
      </h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default RollbackOperationModalHeader;
